import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { GlobalContext } from '../../Context/GlobalContext';
import AddTaskForm from '../AddTaskForm/AddTaskForm';

/**
 * A reusable Paper component for the draggable dialog. This component is used to wrap the dialog content
 * and enable dragging functionality.
 * 
 * @component
 * @param {Object} props - The component props.
 * @param {React.RefObject} props.nodeRef - A ref to the Paper component.
 * @returns {JSX.Element} A draggable Paper component.
 */
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        {...props}
        ref={nodeRef}
        className="formPaper"
        sx={{
          overflow: "auto",
          position: "fixed",
          top: "90px",
          maxWidth: "420px",
          borderRadius: "30px"
        }}/>
    </Draggable>
  );
}

/**
 * A popup dialog component for adding a new task. This component displays a draggable dialog
 * with a form for creating a new task. The form is dynamically rendered based on the task type.
 * 
 * @component
 * @returns {JSX.Element} The rendered dialog component.
 * @example
 * <AddTaskPopup />
 */
function AddTaskPopup() {
  const { newTaskOpen, setNewTaskOpen, taskType } = React.useContext(GlobalContext);

  /**
   * Handles closing the dialog when the user clicks outside, presses the Escape key,
   * or interacts with specific elements.
   * 
   * @param {Event} event - The event triggering the close action.
   */
  const handleClose = (event) => {    
    if (event.nativeEvent.code === "Escape"
      || (event.target.tagName !== "H2"
        && event.target.tagName !== "LI"
        && event.target.tagName !== "DIV")){
          setNewTaskOpen(false);
    }
  };
  
  return (
    <> 
    <Dialog
      open={newTaskOpen}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      PaperProps={{
      sx: {
      height: '90vh',
      maxHeight: '90vh',
      display: 'flex',
       flexDirection: 'column'
      }
      }}
    >
      <DialogTitle style={{ cursor: 'unset' }} id="draggable-dialog-title" onClick={handleClose}>
        New task ({taskType.name})
      </DialogTitle>
      <AddTaskForm taskType={taskType.id}/>
    </Dialog>
  </>
  );
}

export default AddTaskPopup;
